import { VARIABLE_NAME_MAX_LENGTH } from 'ai-constants'

const ALPHANUMERIC_REGEX = new RegExp(/[a-zA-Z0-9_]+/)

const isLowercase = (value: string) => value.toUpperCase() != value

const hasUpperCase = (value: string) => value !== value.toLowerCase()

export const validateVariableName = (name: any): boolean => {
  return (
    typeof name === 'string' &&
    name.length <= VARIABLE_NAME_MAX_LENGTH &&
    ALPHANUMERIC_REGEX.test(name) &&
    !hasUpperCase(name) &&
    !name.includes('.') &&
    !/\s/g.test(name)
  )
}
